module.exports = __webpack_public_path__ + "img/shipped (2) (1).ed00a18e.png";